var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedProduct)?_c('div',[_c('ProductShow',{attrs:{"product":_vm.selectedProduct}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }